import { render, staticRenderFns } from "./GlobalAnimationLoader.vue?vue&type=template&id=6d9c8bb8&"
import script from "./GlobalAnimationLoader.vue?vue&type=script&lang=js&"
export * from "./GlobalAnimationLoader.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAnimationLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports